module.exports = __webpack_public_path__ + "static/media/nabeel.ad0918c3.png";